import React from "react";
import HeroBg from "assets/images/heroBg.jpg";

function Bgsection() {
  return <div className="background-svg bGAnimation"></div>;
}

export default Bgsection;
